import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";

import { asset } from "Services/BaseHelpers";

export default class Convention extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Authenticated title="Dashboard">
                <PageHeader
                    title={"The Convention"}
                    imgSrc={'convention-hero.png'}
                />

                {this.renderOpeningTextSection()}

                <QuestionSection />
            </Authenticated>
        );
    }

    /**
     * @method renderOpeningTextSection
     * @return {*}
     */
    renderOpeningTextSection () {
        return (
            <Section>
                <p className={"bmw-light text-sm"}>
                    At the heart of our event in Cape Town is the Convention and Business Elements which will bring to life why we’ve come to South Africa.
                </p>

                <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 bmw-light text-sm mt-6"}>
                    <div>
                        <p className={"text-left bmw-bold text-sm mt-4"}>
                            Thursday 27 April
                        </p>

                        <p className={"text-left bmw-light text-sm mt-4 mb-4"}>
                            For our Investor, Owner and Franchise Director audience, we want to take this opportunity to talk more
                            about the future roadmap for the BMW Group. We will be hosting a 2 hour morning session with the BMW Group
                            UK Management Committee at One&Only Cape Town.
                        </p>
                        <p className={"text-left bmw-light text-sm mt-4 mb-4"}>
                            This meeting will give you, our Investors, Owners and Franchise Directors, the opportunity to join a smaller and more intimate business discussion as well
                            as hear first-hand from your South African peers about their experience so far with the Future Sales Model.
                        </p>
                        <p className={"text-left bmw-light text-sm mt-4 mb-4"}>
                            This will be your opportunity to hear what the journey has been like for them. We want to make this session as discursive as possible,
                            so please bring your questions.
                        </p>
                    </div>
                    <div>
                        <p className={"text-left bmw-bold text-sm mt-4"}>
                            Friday 28 April
                        </p>

                        <p className={"text-left bmw-light text-sm mt-4"}>
                            On our main convention day, all Investors, Owners, Franchise Directors and Heads of Business will join together for a full-day session.
                        </p>
                        <p className={"text-left bmw-light text-sm mt-4"}>
                            Our aim of the day is to dive deeper into some of the strategic topics mentioned during November’s Retailer Budget Meeting and more recently
                            at the Fast Start Conference in Liverpool.
                        </p>
                        <p className={"text-left bmw-light text-sm mt-4"}>
                            Headline topics include electrification readiness, our vision for digitalisation and
                            the critical role of data, as well as exploring our circularity journey and sustainability credentials. Of course, we will be looking towards the
                            future of our brand and the way we do business, so a portion of the day will be about transforming our business model,
                            and we will be joined by some of your South African Retailer counterparts as part of a panel to discuss how they have navigated this change.
                            It promises to be an informative, inspirational session.
                        </p>
                    </div>
                </div>
            </Section>
        )
    }
}
